<template>
  <specifications-explorer class="container" />
</template>

<script>
import Explorer from '../components/Explorer.vue';

export default {
  name: 'Explorer',
  components: {
    'specifications-explorer': Explorer
  }
}
</script>
